import { get5x5BooleanDataDefinition } from "../Testing/TestData";
import {
    DisplayEditModeTemplate,
    DisplayLayerEditModeTemplate,
    DisplayModeTemplate,
    EditModeTemplate,
    GridTestTemplate,
} from "./CommonStoryTemplates";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { StoryNode } from "../../StoryBook/StoryData";
import React from "react";

let griddef = get5x5BooleanDataDefinition();

let def = new DataDefinition();
let fdef = new BooleanDataDefinition("boolean");
def.fields.push(fdef);

DataUtilities.set(def.getValueObject(), fdef.name, true);

export const BooleanDataEditorStories = [
    new StoryNode(
        () => {
            return <GridTestTemplate definition={griddef}></GridTestTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        "Boolean",
        "Grid",
    ),
    new StoryNode(
        () => {
            return <DisplayModeTemplate definition={def}></DisplayModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        "Boolean",
        "Display Mode",
    ),
    new StoryNode(
        () => {
            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        "Boolean",
        "Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayEditModeTemplate definition={def}></DisplayEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        "Boolean",
        "Display Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={def}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        "Boolean",
        "Display Layer Edit Mode",
    ),
];
